import { useDeferredValue } from "react"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v1CustomerFetchPointsOfInterest } from "@be-miniapp/api"
import type { Location } from "@be-miniapp/types"

interface PointsOfInterestProps {
  point: Location | null | undefined
  enabled?: boolean
}

const usePointsOfInterest = ({
  point,
  enabled = true,
}: PointsOfInterestProps) => {
  const { data, isFetched, isPending } = useQuery({
    queryKey: ["getPointsOfInterest", point?.latitude, point?.longitude, point],
    queryFn: async () => {
      return v1CustomerFetchPointsOfInterest({
        location: point!,
        latitude: point?.latitude ?? 0,
        longitude: point?.longitude ?? 0,
      })
    },

    enabled: enabled && !!point,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  })

  const nearbyPickups = useDeferredValue(data)

  return { nearbyPickups, isFetched, isPending }
}

export { usePointsOfInterest }
